import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { PageHeader } from "../components/AppLayout";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Plus, MapPin } from "lucide-react";

export default function Locations() {
  const { activeOrg } = useAuth();
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ name: "", address: "", suburb: "", state: "", postcode: "", country: "AU" });
  const load = () => activeOrg && api.get(`/orgs/${activeOrg.id}/locations`).then((r) => setRows(r.data));
  useEffect(() => { load(); }, [activeOrg]);
  if (!activeOrg) return null;
  const add = async () => { try { await api.post(`/orgs/${activeOrg.id}/locations`, f); toast.success("Location added"); setOpen(false); setF({ name: "", address: "", suburb: "", state: "", postcode: "", country: "AU" }); load(); } catch (e) { toast.error(apiError(e)); } };
  return (
    <div>
      <PageHeader title="Locations" subtitle="Manage where customers earn rewards."
        action={<Button data-testid="new-location" onClick={() => setOpen(true)} className="bg-[#C8FF4D] text-[#0B0D10] hover:bg-[#b8ef3d] rounded-full font-semibold"><Plus size={16} className="mr-1" />Add location</Button>} />
      {open && (
        <div className="rounded-2xl bg-white border border-[#E8E5DE] p-6 mb-6 max-w-lg grid grid-cols-2 gap-4">
          <div className="col-span-2"><Label>Name</Label><Input className="mt-1.5 bg-white" data-testid="loc-name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} /></div>
          <div className="col-span-2"><Label>Address</Label><Input className="mt-1.5 bg-white" value={f.address} onChange={(e) => setF({ ...f, address: e.target.value })} /></div>
          <div><Label>Suburb</Label><Input className="mt-1.5 bg-white" value={f.suburb} onChange={(e) => setF({ ...f, suburb: e.target.value })} /></div>
          <div><Label>State</Label><Input className="mt-1.5 bg-white" value={f.state} onChange={(e) => setF({ ...f, state: e.target.value })} /></div>
          <div className="col-span-2 flex gap-2"><Button onClick={add} disabled={!f.name} className="bg-[#0B0D10] text-white rounded-full" data-testid="save-location">Save</Button><Button variant="outline" onClick={() => setOpen(false)} className="rounded-full">Cancel</Button></div>
        </div>
      )}
      <div className="grid md:grid-cols-2 gap-4">
        {rows.map((l) => (
          <div key={l.id} className="rounded-2xl bg-white border border-[#E8E5DE] p-5 flex items-start gap-3" data-testid={`location-${l.id}`}>
            <MapPin size={20} className="text-[#6474FF] mt-0.5" />
            <div><h3 className="font-display font-semibold">{l.name}</h3><p className="text-sm text-[#25282E]">{[l.address, l.suburb, l.state, l.postcode].filter(Boolean).join(", ")}</p></div>
          </div>
        ))}
      </div>
    </div>
  );
}
